import { Datei } from "./datei.model";
import { AuspraegungGebaeudeUebersicht } from "./auspraegung-gebaeude-uebersicht.model";
import { AuspraegungGebaeude } from "./auspraegung-gebaeude.model";


export class Gebaeude {
    idGebaeude!: number;
    bezeichnung!: string;
    dateiList!: Datei[];
     
    auspraegungGebaeude!: AuspraegungGebaeude[];  
    tierplaetze!: AuspraegungGebaeude[];  
    flaechenVolumen!: AuspraegungGebaeude[];  


    auspraegungGebaeudeUebersicht!: AuspraegungGebaeudeUebersicht[];  
   }
 

   